import { render, staticRenderFns } from "./api-menu.vue?vue&type=template&id=20afcb89&scoped=true"
import script from "./api-menu.vue?vue&type=script&lang=js"
export * from "./api-menu.vue?vue&type=script&lang=js"
import style0 from "./api-menu.scss?vue&type=style&index=0&id=20afcb89&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_ec1e824a4fe600ca080e24d3f05cd390/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20afcb89",
  null
  
)

export default component.exports